import type { OnChangeFn } from "@dresscode-frontend/utility-types";
import { useCallback } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";

type Props = {
  value?: boolean;
  onChange: OnChangeFn<boolean | undefined>;
};

export function UnassignedDeviceToggle({ value, onChange }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.components.deviceFilters.assigned",
  });

  const handleClick = useCallback(() => {
    // undefined: 全デバイス表示（フィルターなし）
    // false: 未割り当てデバイスのみ表示
    // true: 割り当て済みデバイスのみ表示（現在は未使用だが、型定義上は許容）
    // トグル動作: false ⇄ undefined
    onChange(value === false ? undefined : false);
  }, [value, onChange]);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleClick}
      className={cn(
        "transition-colors",
        value === false &&
          "bg-primary-fill text-primary-on-fill hover:bg-primary-fill-hovered border-primary-fill",
      )}
    >
      {t("label")}
    </Button>
  );
}
